import { createPermission } from "@backstage/plugin-permission-common";

/** Permission required to access admin-only features. */
export const administerPermission = createPermission({
    name: "admin.administer",
    attributes: {},
});

/** Full list of permissions defined by the admin plugin, for use in backend registration. */
export const adminPermissions = [administerPermission];
